import { CultureInfo } from '../culture-info.model';
import { CultureInfoNl } from './nl';

/**
 * @ignore
 */
export const CultureInfoNlAW: CultureInfo = {
  name: 'nl-AW',
  displayName: 'Nederlands (Aruba)',
  iso3LanguageCode: 'nld',
  iso2LanguageCode: 'nl',
  ietfLanguageTag: 'nl-AW',
  parent: CultureInfoNl
};
